module.exports = __webpack_public_path__ + "ic_file_download_black_24px.svg?df34aea05639eb0208cb21c22636d29a";